module.exports = __webpack_public_path__ + "static/media/LG2100199.10cb9588.png";